define('presentation/common/routeToModal/presentationObjects/voicemailBoxPresentationObject',[],function() {
    return function(){
        var self = this;
        self.voicemailBoxId = null;
        self.voicemailBoxName = null;
    };
});
